import { hideScrollBar } from '@repo/ui/components/utilities';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexRow } from 'styles/layouts';

export const cardWidth = 245;

export const Wrapper = styled.div`
  position: relative;
`;

export const CarouselContainer = styled.div`
  border: 1px solid ${themeStyle.varInkLight};
  border-radius: 20px;

  background-color: ${themeStyle.varInkSuperLight};
  overflow: hidden;

  padding: 32px 0;
`;

export const ItemsWrapper = styled(FlexRow)<{
  gap: number;
}>`
  align-items: center;
  white-space: nowrap;
  user-select: none;
  overflow-x: auto;

  padding: 0 32px;

  gap: ${({ gap }) => gap}px;

  ${hideScrollBar}
`;

export const TileWrapper = styled.div`
  min-width: ${cardWidth}px;
`;

export const ScrollButtonBase = styled.button<{ align: 'left' | 'right' }>`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: ${themeStyle.varBackgroundAlt};
  outline: none;
  border: none;
  border-radius: 50%;
  float: ${({ align }) => align};

  top: 50%;

  filter: ${themeStyle.varFilterShadowHeavy};
  cursor: pointer;
`;

export const ScrollLeftButton = styled(ScrollButtonBase)`
  left: 0;
  transform: translate(-50%, -50%);
`;

export const ScrollRightButton = styled(ScrollButtonBase)`
  right: 0;
  transform: translate(50%, -50%);
`;
